module.exports = __webpack_public_path__ + "img/nav_b1_img3.4b2d5992.png";